import { ref, watch, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'

export function useRouterPagination(
  fetchCallback: (page: number) => Promise<void>,
  defaultPage = 1
) {
  const route = useRoute()
  const router = useRouter()
  const currentPage = ref(defaultPage)

  const initializePage = () => {
    const pageFromRoute = route.query.page
    if (pageFromRoute && typeof pageFromRoute === 'string') {
      const pageNum = parseInt(pageFromRoute, 10)
      if (pageNum > 0) {
        currentPage.value = pageNum
      }
    }
  }

  const updatePage = (page: number) => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    router.push({
      query: { ...route.query, page: page.toString() }
    })
  }

  // Watch route changes
  watch(() => route.query.page, (newPage) => {
    const pageNum = newPage && typeof newPage === 'string' ? parseInt(newPage, 10) : defaultPage
    if (pageNum > 0 && pageNum !== currentPage.value) {
      currentPage.value = pageNum
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      fetchCallback(pageNum)
    }
  })

  onMounted(() => {
    initializePage()
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    fetchCallback(currentPage.value)
  })

  return {
    currentPage,
    updatePage,
    initializePage
  }
}